import Vue from 'vue'
import App from './App'
import router from './router/router'
import store from '../store'
import Roboto from 'roboto-fontface'
import 'vue-awesome/icons'
import Notifications from 'vue-notification'
import moment from 'moment'
import VueMoment from 'vue-moment'
import 'moment/locale/ru'
import * as Sentry from '@sentry/browser'
import { Vue as VueIntegration } from '@sentry/integrations'

Vue.use(VueMoment, {
  moment
})

Vue.use(Notifications)

Sentry.init({
  dsn: process.env.API_SENTRY_KEY,
  integrations: [new VueIntegration({ Vue, attachProps: true })]
})

// FILTERS
Vue.filter('uppercase', function (value) {
  if (!value) return ''
  value = value.toUpperCase()
  return value
})

Vue.filter('lowercase', function (value) {
  if (!value) return ''
  value = value.toLowerCase()
  return value
})

Vue.filter('yesno', function (value) {
  return value ? 'Да' : 'Нет'
})

Vue.filter('date', function (value) {
  return moment(value).format('D MMMM YYYY')
})

Vue.filter('datetime', function (value) {
  return moment(value).format('D MMMM YYYY, HH:mm:ss')
})

Vue.filter('age', function (value) {
  let age = value
  let label
  let last = age.toString().slice(-1)
  if (last === 1) {
    label = 'год'
  } else if (last >= 2 && last <= 4) {
    label = 'года'
  } else label = 'лет'

  return `${age} ${label}`
})

Vue.filter('gender', function (value) {
  return value === 2 ? 'Женский' : value === 1 ? 'Мужской' : 'Нет данных'
})

Vue.config.productionTip = false

// RUNNING APP
new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
